import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Maintenance from "./pages/Maintenance";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Maintenance />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
